import type { DiscoveryContentCategoryNode } from "@amzn/ads-discovery-theme-service-typescript-client";
import { isEmpty, sortBy } from "lodash";

import type { FilterToCategoryValue } from "../config/categories.config";
import { FilterToCategoriesMapping } from "../config/categories.config";
import type { Item } from "../types/common";
import { MarketingNarrativesFilterField } from "../types/filters/marketingNarratives";

export const getItemFromCategory = (
    category: FilterToCategoryValue,
): Item | undefined => {
    if (
        category.categoriesToMap !== undefined &&
        category.categoriesToMap.length > 0
    ) {
        return {
            label: category.displayName,
            value: category.categoriesToMap
                .map((c) => c.contentCategoryId)
                .join("|"),
        };
    } else if (category.contentCategoryId) {
        return {
            label: category.displayName,
            value: category.contentCategoryId,
        };
    }
};

export const getItemsFromCategories = (
    categories: FilterToCategoryValue[],
): Item[] => {
    const items: Item[] = [];
    categories.forEach((category: FilterToCategoryValue) => {
        const item = getItemFromCategory(category);
        if (item !== undefined) {
            items.push(item);
        }
    });
    return items;
};

export const getMarketingNarrativeFiltersOptionsFromCategories = (): {
    [key in MarketingNarrativesFilterField]: Item[];
} => {
    return Object.keys(MarketingNarrativesFilterField).reduce(
        (acc, currentValue) => {
            acc[currentValue] = [
                ...sortBy(
                    getItemsFromCategories(
                        FilterToCategoriesMapping[
                            MarketingNarrativesFilterField[currentValue]
                        ],
                    ),
                    (item) => item.label,
                ),
            ];
            return acc;
        },
        {} as { [key in MarketingNarrativesFilterField]: Item[] },
    );
};

export const getCategoryMap = (): {
    [categoryId: string]: DiscoveryContentCategoryNode;
} => {
    return Object.keys(MarketingNarrativesFilterField).reduce(
        (acc, currentValue) => {
            const categories =
                FilterToCategoriesMapping[
                    MarketingNarrativesFilterField[currentValue]
                ];
            categories.forEach((category: FilterToCategoryValue) => {
                if (
                    category.categoriesToMap !== undefined &&
                    category.categoriesToMap.length > 0
                ) {
                    category.categoriesToMap.forEach((childCategory) => {
                        if (childCategory.contentCategoryId) {
                            acc[childCategory.contentCategoryId] = {
                                contentCategoryId:
                                    childCategory.contentCategoryId,
                                displayName: childCategory.displayName,
                            };
                        }
                    });
                } else if (category.contentCategoryId) {
                    acc[category.contentCategoryId] = {
                        contentCategoryId: category.contentCategoryId,
                        displayName: category.displayName,
                    };
                }
            });
            return acc;
        },
        {} as { [categoryId: string]: DiscoveryContentCategoryNode },
    );
};
export const getCategoryIds = (category: FilterToCategoryValue): string[] => {
    const categoryIdsToCheck: string[] = [];
    if (
        category.categoriesToMap !== undefined &&
        !isEmpty(category.categoriesToMap)
    ) {
        category.categoriesToMap.forEach((category) => {
            if (category.contentCategoryId) {
                categoryIdsToCheck.push(category.contentCategoryId);
            }
        });
    } else {
        if (category.contentCategoryId) {
            categoryIdsToCheck.push(category.contentCategoryId);
        }
    }
    return categoryIdsToCheck;
};
